export default "__VITE_ASSET__eec915a1__"